import { useCallback, useSyncExternalStore } from 'react';
import { useDocumentStore } from './useDocumentStore';
import { JsonPointerPath } from 'types/dynamic-forms/JsonPointerPath';

export default function useDataSource(path: JsonPointerPath) {
  const store = useDocumentStore();

  const getOptions = useCallback(() => store.getOptions(path), [path, store]);
  const invalidateDataSource = useCallback(() => store.invalidateDataSource(path), [path, store]);

  const options = useSyncExternalStore(store.addDataChangedListener, getOptions);
  return { options, invalidateDataSource };
}
